"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _l10n = _interopRequireDefault(require("../../../common/l10n"));

var _react = _interopRequireDefault(require("react"));

var _default = function _default(item, options) {
  var isSelected = options.isSelected,
      isSelectItem = options.isSelectItem,
      isReactComponent = _react["default"].isValidElement(item.name);

  var content = null,
      title = '';

  if (typeof item.stringName === 'string') {
    title = _l10n["default"].translate(item.stringName);
  } else if (typeof item.name === 'string') {
    title = _l10n["default"].translate(item.name);
  }

  if (isReactComponent) {
    content = // performance optimization. Run render only on selected items. Normal items are stored in
    // item.name
    typeof item.render === 'function' && (isSelected || isSelectItem) ? item.render({
      selected: isSelected,
      selectItem: isSelectItem
    }) : item.name;
  } else {
    content = title;
  }

  return {
    content: content,
    title: title,
    id: item.id
  };
};

exports["default"] = _default;